<template>
  <section class="ba-mb-4">
    <h5 class="ba-mb-2 ba-font-bold ba-text-primary">Задачу поставил</h5>
    <vis-approval-queue-user
      :user="user"
      :date="date"
      :time="time"
      class="ba-mb-2"
    />
    <p class="ba-text-sm">{{ description }}</p>
  </section>
</template>

<script>
import visApprovalQueueUser from "./vis-approval-queue-user";

export default {
  name: "vis-approval-queue-task-description",
  components: {
    visApprovalQueueUser
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    date: {
      type: String,
      default: null
    },
    time: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  }
}
</script>
